module.exports = __webpack_public_path__ + "__static/site-1783523783704/img/octopus-star3.3dc9b7a2.png";